import { CardTagStatus } from "~config/constants"
import type { MinimalTeamMemberFieldsFragment } from "~graphql/team-members.generated"
import type { TeamMemberRole } from "~graphql/generated/types"
import { getCleanEnum } from "~utils/helpers/string-helpers"

export function formatTeamMemberRole(role: TeamMemberRole) {
    return getCleanEnum(role.replace("_", "-"))
}

export function getTeamMemberStatus(
    member?: MinimalTeamMemberFieldsFragment | null
) {
    return member?.user ? CardTagStatus.Accepted : CardTagStatus.Pending
}
